export class BulkActionInfo {
    constructor(public name: string, public description: string) { }
}